import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../assets/styles/Navigation.css';

function Navigation() {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <nav className="navbar">
            <div className="burger-icon" onClick={toggleMenu}>
                <div className="line"></div>
                <div className="line"></div>
                <div className="line"></div>
            </div>
            <ul className={`nav-links ${isOpen ? 'open' : ''}`}>
                <li><Link to="/fizzbuzz" onClick={toggleMenu}>FizzBuzz</Link></li>
                <li><Link to="/firstnonrepeatingchar" onClick={toggleMenu}>FirstNonRepeatingChar</Link></li>
                <li><Link to="/fixgroup" onClick={toggleMenu}>FixGrouping</Link></li>
                <li><Link to="/longestincresingstring" onClick={toggleMenu}>LongestIncreasingString</Link></li>
                <li><Link to="/palindrome" onClick={toggleMenu}>Palindrome</Link> </li>
                <li><Link to="/duplicates" onClick={toggleMenu}>RemoveDuplicates</Link></li>
                <li><Link to="/zweierpotenz" onClick={toggleMenu}>Zweier Potenz</Link></li>
                <li><Link to="/movezeros" onClick={toggleMenu}>Nullen verschieben</Link></li>
            </ul>
        </nav>
    );
}

export default Navigation;
